export function configureRendererLayers(layers) {
    const sceneLayers = [layers.webgl, layers.css, layers.overlay];
    for (const layer of sceneLayers) {
        layer.style.position = 'absolute';
        layer.style.inset = '0';
    }
    layers.webgl.style.zIndex = '1';
    layers.webgl.style.pointerEvents = 'none';
    // CSS3D contains the interactive monitor iframe, so it must render over
    // the opaque WebGL monitor while the root itself stays click-through.
    layers.css.style.zIndex = '2';
    layers.css.style.pointerEvents = 'none';
    layers.overlay.style.zIndex = '3';
    layers.overlay.style.pointerEvents = 'none';
    layers.uiInteractive.style.zIndex = '4';
    layers.ui.style.zIndex = '4';
}
